import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";
import { roundNumber } from '../../utils/roundNumber';
import DonutChart from '../DonutChart';
import { useRef } from "react";
import toast from "react-hot-toast";
import CustomBarChart from "../ui/CustomBarChart";

const limit = 6;

const WisdomDashboardSubDataDetails = ({
    isOpen, onClose, onDetails, selectedMonthIdx,
    toggleMonth, selectedMonth, datasMonths,
    selectedOrg, orgSubStandards,
    setSelectedFormCode,
    subjects, setSelectedSubject, selectedSubject,
    stages, setSelectedStage, selectedStage,
    specializations, setSelectedSpecialization, selectedSpecialization,
    toDate, setToDate, setFromDate, fromDate
}) => {
    const scrollRef = useRef([]);

    const totalCodes = orgSubStandards?.codes?.length;

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto p-4">
            <div className="min-w-[50%] w-fit md:max-w-[70%] max-w-full max-h-[84vh] bg-white rounded-lg overflow-y-auto flex flex-col justify-center items-center" style={{
                backgroundColor: "#2d3347"
            }}>
                {/* Navbar */}
                <div className="flex items-center justify-between px-6 py-2 w-full" style={{ backgroundColor: '#1e293b' }}>
                    <button onClick={onClose} className="hover:bg-gray-700 w-10 h-10 rounded-full flex justify-center items-center text-white">
                        <FontAwesomeIcon icon={faX} />
                    </button>
                    <div className='flex gap-4 justify-center items-center'>
                        <h1 className='text-xl'>{selectedOrg?.name}</h1>
                        <div className='h-4 border-l-2 border-white w-0' />
                        <h1 className='text-xl'>{orgSubStandards?.name}</h1>
                    </div>
                </div>

                {/* Main Content */}
                <div className="flex flex-col justify-center items-center w-full gap-2 p-2">
                    {/* data's total score */}
                    <div className='flex flex-col justify-center items-center w-full max-w-[1040px] rounded-2xl gap-6 p-4' style={{ backgroundColor: '#1e293b' }}>
                        {/* month navigator */}
                        <div className="flex items-center gap-4">
                            {selectedMonthIdx !== 0 ? (
                                <button
                                    onClick={() => toggleMonth(false)}
                                    style={{
                                        background: '#181f2e',
                                        color: '#0af',
                                        border: 'none',
                                        borderRadius: '50%',
                                        width: 36,
                                        height: 36,
                                        fontSize: 22,
                                        fontWeight: 900,
                                        cursor: 'pointer',
                                        boxShadow: '0 2px 8px #0006',
                                    }}
                                    title="الشهر السابق"
                                >
                                    &#8592;
                                </button>
                            ) : (
                                <div style={{ width: 36, height: 36 }} />
                            )}

                            <span
                                style={{
                                    color: '#fff',
                                    fontWeight: 700,
                                    fontSize: 15,
                                    minWidth: 80,
                                    textAlign: 'center',
                                    letterSpacing: 1,
                                }}
                            >
                                {selectedMonth?.month}
                            </span>

                            {selectedMonthIdx !== datasMonths.length - 1 ? (
                                <button
                                    onClick={() => toggleMonth(true)}
                                    style={{
                                        background: '#181f2e',
                                        color: '#0af',
                                        border: 'none',
                                        borderRadius: '50%',
                                        width: 36,
                                        height: 36,
                                        fontSize: 22,
                                        fontWeight: 900,
                                        cursor: 'pointer',
                                        boxShadow: '0 2px 8px #0006',
                                    }}
                                    title="الشهر التالي"
                                >
                                    &#8594;
                                </button>
                            ) : (
                                <div style={{ width: 36, height: 36 }} />
                            )}
                        </div>
                        <div className='flex w-full max-w-[700px] justify-center items-center gap-12' dir="rtl">
                            <div className="flex-1">
                                <button
                                    className="flex-1 w-full flex items-center gap-2 hover:bg-slate-300 px-3 py-1 rounded-full bg-white text-black text-sm font-semibold cursor-pointer"
                                    onClick={() => {
                                        setFromDate("");
                                        setToDate("");
                                    }}
                                >
                                    ازالة فلتر تاريخ
                                </button>
                                <label className="flex-1 flex items-center gap-2 px-3 py-1 rounded-full bg-white text-black text-sm font-semibold cursor-pointer">
                                    من:
                                    <input
                                        type="date"
                                        value={fromDate}
                                        onChange={(e) => setFromDate(e.target.value)}
                                        className="bg-transparent outline-none text-sm cursor-pointer"
                                    />
                                </label>
                                <label className="flex-1 flex items-center gap-2 px-3 py-1 rounded-full bg-white text-black text-sm font-semibold cursor-pointer">
                                    إلى:
                                    <input
                                        type="date"
                                        value={toDate}
                                        onChange={(e) => setToDate(e.target.value)}
                                        className="bg-transparent outline-none text-sm cursor-pointer"
                                    />
                                </label>
                            </div>
                            {/* Overall Score Circle */}
                            <div className="flex-1 flex items-center justify-center gap-2">
                                <DonutChart value={orgSubStandards?.score || 0} size={100} color='url(#circularBlueGradient)' bg='#23263a' textColor='#fff' />
                            </div>
                            <div className="flex-1 flex flex-col gap-2">
                                <select className="flex-1 w-full flex items-center gap-2 px-3 py-1 rounded-full bg-white text-black text-xs font-semibold cursor-pointer" value={selectedSpecialization} onChange={(e) => setSelectedSpecialization(e.target.value)}>
                                    <option value="" disabled>الرجاء اختيار تخصص الطلاب</option>
                                    <option value="All">الكل</option>
                                    {specializations.map(specialization =>
                                        <option value={specialization.id}>{specialization.name}</option>
                                    )}
                                </select>
                                <select className="flex-1 w-full flex items-center gap-2 px-3 py-1 rounded-full bg-white text-black text-xs font-semibold cursor-pointer" value={selectedStage}
                                    onChange={(e) => setSelectedStage(e.target.value)}>
                                    <option value="" disabled>الرجاء اختيار المرحلة التعليمية</option>
                                    <option value="All">الكل</option>
                                    {stages.map(stage =>
                                        <option value={stage.id}>{stage.name}</option>
                                    )}
                                </select>
                                <select className="flex-1 w-full flex items-center gap-2 px-3 py-1 rounded-full bg-white text-black text-xs font-semibold cursor-pointer" value={selectedSubject} onChange={(e) => setSelectedSubject(e.target.value)}>
                                    <option value="" disabled>الرجاء اختيار المادة</option>
                                    <option value="All">الكل</option>
                                    {subjects.map(subject =>
                                        <option value={subject.id}>{subject.name}</option>
                                    )}
                                </select>
                            </div>
                        </div>
                    </div>
                    {/* data's and sub-data's section */}
                    <div
                        className="flex flex-col justify-center items-center w-full rounded-2xl p-2 gap-2"
                        style={{ backgroundColor: "#3d4f6dff" }}
                    >
                        <h1 className="text-white text-center text-sm py-2 bg-sky-900 rounded-xl p-2 w-full min-h-[55px] flex justify-center items-center">
                            {orgSubStandards?.code === "TMS" ? "نسبة اكمال المهام" : "عدد التقييمات"}
                        </h1>
                        <div className="w-full flex justify-between">
                            {orgSubStandards.codes.map((item, j) => (
                                <div className="w-full flex justify-center items-center gap-2">
                                    <h1 className="w-10 h-10 flex justify-center items-center bg-sky-900 rounded-full text-sm">
                                        {orgSubStandards?.scores?.filter((f) => f.code === item.code).length}
                                    </h1>
                                </div>
                            ))}
                        </div>

                        {/* Scrollable Container */}
                        <div
                            ref={scrollRef}
                            className={`flex w-full items-center gap-2 ${totalCodes > limit
                                ? "justify-start overflow-x-auto overflow-y-hidden no-scrollbar"
                                : "justify-center"
                                }`}
                        >
                            <div
                                className="w-full flex flex-col rounded-2xl justify-center items-center flex-shrink-0"
                            >
                                {orgSubStandards?.codes && orgSubStandards?.codes?.length > 0 && (
                                    <div className="flex flex-col w-full gap-1 rounded-2xl p-2 min-h-48" >
                                        <div className="w-full flex justify-center items-center bg-[#1e293b] rounded-2xl p-2">
                                            {orgSubStandards.codes.map((item, j) => (
                                                <div
                                                    key={j}
                                                    className="max-w-[250px] min-w-[200px] min-h-44 flex flex-col justify-center items-center gap-2 flex-shrink-0 transition-transform duration-300 ease-out will-change-transform"
                                                    style={{
                                                        width: `${(1 / orgSubStandards.codes.length) * 100}%`
                                                    }}
                                                >
                                                    <div className="w-full flex justify-center items-center rounded-xl" >
                                                        <CustomBarChart
                                                            title={""}
                                                            value={roundNumber(item.average_score * 100) || 0}
                                                            maxValue={100}
                                                            width={90}
                                                            height={110}
                                                            barColor={item.average_score === 0 ? "#ff3232" : "#38bdf8"}
                                                            bgColor="transparent"
                                                            onBarClick={() => orgSubStandards.scores.filter((f) => f.code === item.code).length > 0 ? (onDetails(), setSelectedFormCode(item.code)) : toast.error("لا يوجد تقييمات")}
                                                        />
                                                    </div>
                                                    <h1 className={`text-white text-center text-sm py-2 bg-sky-900 p-2 w-full min-h-[55px] flex justify-center items-center ${orgSubStandards.codes.length === 1 ? "rounded-b-2xl" : (j === 0 && orgSubStandards.codes.length === 1) ? "rounded-bl-2xl" : j === orgSubStandards.codes.length - 1 ? "rounded-br-2xl" : ""}`}>
                                                        {item.name}
                                                    </h1>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WisdomDashboardSubDataDetails;